import {Component, inject, input} from '@angular/core';
import {ProductCardData} from "../../../types/product-card-data.types";
import {defaultProductCardData} from "../../../configs/default-product-card-data";
import {MatDialog} from "@angular/material/dialog";
import {ArticleMarketplaceStateService} from "../../../services-state/article-marketplace-state.service";
import {
  ArticleMarketplaceModalComponent
} from "../../modals/article-marketplace-modal/article-marketplace-modal.component";
import {articleButtons, productCardFields } from '../../../configs/product-card-header-config';
import {MatTooltip} from "@angular/material/tooltip";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {PcRatingComponent} from "../pc-rating/pc-rating.component";
import {PcDefectsComponent} from "../pc-defects/pc-defects.component";
import {PcParametersComponent} from "../pc-parameters/pc-parameters.component";
import {ProductCardModalsService} from "../../../services/product-card-modals.service";

@Component({
  selector: 'app-pc-header',
  standalone: true,
  imports: [
    MatTooltip,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatButton,
    PcRatingComponent,
    PcDefectsComponent,
    PcParametersComponent
  ],
  templateUrl: './pc-header.component.html',
  styleUrl: './pc-header.component.scss'
})
export class PcHeaderComponent {
  productCardId = input<number>(0);
  productCardData = input<ProductCardData>(defaultProductCardData);
  isVisibleDesc = input<boolean>(true);

  private dialog: MatDialog = inject(MatDialog);
  private articleMarketplaceStateService: ArticleMarketplaceStateService = inject(ArticleMarketplaceStateService);
  private productCardModalsService: ProductCardModalsService = inject(ProductCardModalsService);

  public readonly productCardFields = productCardFields;
  public readonly articleButtons = articleButtons;

  public getTooltip(key: keyof ProductCardData): string {
    return this.productCardData()[key]?.toString() || '';
  }

  public isBtnDisabled(key: string): boolean {
    return !this.articleMarketplaceStateService.articleMarketplacesState()[key].length;
  }

  public handleArticleMarketplace(key: string): void {
    this.dialog.open(ArticleMarketplaceModalComponent, {
      data: { marketplace: key },
      width: '480px'
    });
  }

  public async handleOpenSyncCompetitorArticle(): Promise<void> {
    await this.productCardModalsService.openSyncCompetitorArticleModal(this.productCardId());
  }
}
